import React, {Component} from 'react';

import './Icons.css';


export class Twitter extends Component {
  render() {
    return (
      <svg className="l-social-icon" xmlns="http://www.w3.org/2000/svg" width='40' height ='40' viewBox="0 0 40 40">
        <path d="M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20S31,0,20,0 M27.8,15.9L27.8,15.9l0,0.1c0,0,0,0,0,0
          C28,22.5,23,27.8,16.6,27.8c-2.2,0-4.4-0.6-6.3-1.8c2.7,0.4,5.1-0.9,5.8-1.7c-1.8,0-3.5-1.5-3.6-2.7c0.4,0.1,1.2,0.1,1.7-0.1
          c-2.4-0.7-3.1-2.5-3.1-3.9c0.4,0.4,1.3,0.5,1.8,0.5c-1.4-0.9-2.4-3.2-1.2-5.3c2,2.6,5.3,4.1,8.3,4.2c-0.5-2.2,0.9-4.3,3-4.8
          c1.4-0.3,2.8,0.1,3.8,1.1c0.6,0,1.9-0.5,2.5-0.9c-0.2,0.8-1.1,1.9-1.7,2.2c0.9-0.1,1.9-0.4,2.2-0.6C29.2,14.7,28.6,15.4,27.8,15.9"
          />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/components/footer/socialIcons/Twitter.js